import React, {useEffect, useState} from "react";
import {Switch, Text, Tile} from "@wakelet/ui-kit";
import {translateKey} from "../language/translate";
import {getAccountApiUrl} from "../../env/env";
import {useAuth} from "../auth/AuthContext";
import {User} from "../auth/types";
import {Spinner} from "../loading/Spinner";

const settingsUrl = getAccountApiUrl("/user-preferences");

export const Preferences: React.FC = () => {
  const [isEducator, setIsEducator] = useState(false);
  const {loading, user} = useAuth()

  useEffect(() => {
    if (loading || !user) {
      return
    }
    (async () => {
        await getEduStatus(user)
      }
    )()
  }, [loading, user]);

  const getEduStatus = async (user: User) => {
    const token = await user.getIdToken();
    const res = await fetch(settingsUrl, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const settings = await res.json();
    const checked = "sectors" in settings && settings.sectors.includes("Education");
    setIsEducator(checked);
  }

  const changeEduStatus = async (checked: boolean) => {
    const token = await user?.getIdToken();
    let newSectors = {sectors: ["Education"]};
    if (!checked) {
      newSectors = {sectors: []};
    }
    await fetch(settingsUrl, {
      method: "PUT",
      body: JSON.stringify(newSectors),
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    setIsEducator(checked);
  }

  if (loading) {
    return <Spinner/>
  }

  return (<Tile>
    <Text.Heading level={3}>{translateKey("account:placeholders.preferences")}</Text.Heading>

    <Text>{translateKey("settings:manageAccount.switchEducationFlag.description")}</Text>
    <div className="flex justify-end">
      <Switch id="Edu Switch"
              data-testid="is-educator-switch"
              label={translateKey("settings:manageAccount.switchEducationFlag.header")}
              aria-labelledby={translateKey("settings:manageAccount.switchEducationFlag.header")}
              checked={isEducator}
              disabled={loading}
              onChange={changeEduStatus}/>
    </div>
  </Tile>)
}
